export const RulesAdvice = [
    "Value the most expensive players between 7-11m and the least expensive between 1-4m.",
    "Remember that you can use 1 decimal place when setting values (doing so can create more dynamic team selections).",
    "Limit the number of players worth 11m as choosing someone this expensive really limits team selection options.",
    "You can now bulk edit player values so it'll be easier to make quick changes to get the balance right.",
    "Use play-cricket to view stats from last season when working out who is the most expensive - after all the stats never lie!"
];